import { SocialNetworking } from '../components/SocialNetworking';

export default function NetworkPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">Social Network</h1>
          <p className="text-muted-foreground mt-1">
            Connect, share insights, and collaborate with other professionals
          </p>
        </div>
      </div>
      <SocialNetworking />
    </div>
  );
}
